/**
 * @deprecated:
 * We should use the version from API-client
 * NOTE: Was too big to remove at once, so be mindfull of old references and clean it up.
 */
export enum StopType {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}

export enum SessionStorageKeys {
  IS_TRANSACTION_EVENT_FIRED = 'IS_TRANSACTION_EVENT_FIRED',
  LANDING_PAGE_ITEM_ACTION = 'LANDING_PAGE_ITEM_ACTION',
  PRODUCT_SELECTION_FORM = 'PRODUCT_SELECTION_FORM',
  FLOOR_SUS_PICKUP = 'FLOOR_SUS_PICKUP',
  FLOOR_SUS_DELIVERY = 'FLOOR_SUS_DELIVERY',
  INSTRUCTION_SUS_PICKUP = 'INSTRUCTION_SUS_PICKUP',
  INSTRUCTION_SUS_DELIVERY = 'INSTRUCTION_SUS_DELIVERY',
  BRENGER_FORM = 'BRENGER_FORM',
}

export enum LocalStorageKeys {
  PAYMENT_EVENT_IDS = 'payment_event_ids',
  PAYMENT_ERROR_EVENT_IDS = 'payment_error_event_ids',
  LANGUAGE_PREFERENCE = 'language_preference',
  UNIFIED_FLOW_MODAL_SEEN = 'unified_flow_modal_seen',
}

export enum BaseActionTypes {
  START_APP_LOADING = `@@base/START_APP_LOADING`,
  STOP_APP_LOADING = `@@base/STOP_APP_LOADING`,
}

export interface GeneralBaseAction {
  type: BaseActionTypes.START_APP_LOADING | BaseActionTypes.STOP_APP_LOADING;
}

export enum CacheKey {
  RETRIEVE_PS_SEARCH = 'RETRIEVE_PS_SEARCH',
  RETRIEVE_TRANSPORT_REQUEST = 'RETRIEVE_TRANSPORT_REQUEST',
  RETRIEVE_TRANSPORT_REQUEST_LIST = 'RETRIEVE_TRANSPORT_REQUEST_LIST',
  RETRIEVE_TRANSPORT_REQUEST_LIVE_TRACKING = 'RETRIEVE_TRANSPORT_REQUEST_LIVE_TRACKING',
  RETRIEVE_TRANSPORT_REQUEST_STOP_CONTACT = 'RETRIEVE_TRANSPORT_REQUEST_STOP_CONTACT',
  RETRIEVE_TRANSPORT_REQUEST_CANCELLATION_COSTS = 'RETRIEVE_TRANSPORT_REQUEST_CANCELLATION_COSTS',
  RETRIEVE_TRANSPORT_JOB_ACCOUNT_LINK = 'RETRIEVE_TRANSPORT_JOB_ACCOUNT_LINK',
  RETRIEVE_TRANSPORT_JOB_ACCOUNT_LINK_LIST_FOR_TR = 'RETRIEVE_TRANSPORT_JOB_ACCOUNT_LINK_LIST_FOR_TR',
  RETRIEVE_TRANSPORT_JOB_ACCOUNT_LINK_MESSAGES = 'RETRIEVE_TRANSPORT_JOB_ACCOUNT_LINK_MESSAGES',
  RETRIEVE_ITEM_SET = 'RETRIEVE_ITEM_SET',
  RETRIEVE_PRODUCT_PAYMENT = 'RETRIEVE_PRODUCT_PAYMENT',
  RETRIEVE_INVOICES = 'RETRIEVE_INVOICES',
  RETRIEVE_QUOTE = 'RETRIEVE_QUOTE',
  RETRIEVE_GEO_PLACE = 'RETRIEVE_GEO_PLACE',
  RETRIEVE_GEO_LOCATION = 'RETRIEVE_GEO_LOCATION',
  RETRIEVE_IMAGE = 'RETRIEVE_IMAGE',
  RETRIEVE_ADDRESS = 'RETRIEVE_ADDRESS',
  RETRIEVE_LINE_1 = 'RETRIEVE_LINE_1',
  RETRIEVE_POSTAL_CODE = 'RETRIEVE_POSTAL_CODE',
  RETRIEVE_PUBLIC_DATA = 'RETRIEVE_PUBLIC_DATA',
  RETRIEVE_HISTORICAL_ADDRESS_LIST = 'RETRIEVE_HISTORICAL_ADDRESS_LIST',
  RETRIEVE_PS_PRODUCT_GROUP = 'RETRIEVE_PS_PRODUCT_GROUP',
  RETRIEVE_PS_PRESETS = 'RETRIEVE_PS_PRESETS',
  API_KEY_LIST = 'API_KEY_LIST',
  RETRIEVE_THANK_YOU_DATA = 'RETRIEVE_THANK_YOU_DATA',
  RETRIEVE_OPP_METHODS = 'RETRIEVE_OPP_METHODS',
  VAT_NUMBER_VALIDATOR = 'VAT_NUMBER_VALIDATOR',
  DEFERRED_VAT_ELIGIBILITY = 'DEFERRED_VAT_ELIGIBILITY',
  RETRIEVE_STRUCTURED_ADDRESS_BY_POSTAL_CODE = 'RETRIEVE_STRUCTURED_ADDRESS_BY_POSTAL_CODE',
  RETRIEVE_ACTIVE_DISCOUNT = 'RETRIEVE_ACTIVE_DISCOUNT',
}

export enum QuotesErrorTitles {
  OUTSIDE_SERVICE_AREA = 'At least one stop is outside the service area',
  ROUTE_CALCULATION_NOT_POSSIBLE = 'Could not grade route',
}
